import styled from "styled-components";

const Overlay = styled.div`
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(20, 27, 37, 0.95);
  display: flex;
  flex-direction: column;
  z-index: 10000;
`;

const Iframe = styled.iframe`
  width: 100%;
  height: calc(100vh - 48px);
  border: none;
`;

const OHIFIframeViewer = ({ url }) => {
  if (!url) return null;

  console.log("Opening OHIF Viewer with URL:", url);

  return (
    <Overlay>
      <Iframe src={url} />
    </Overlay>
  );
};

export default OHIFIframeViewer;
